import { Injectable } from "@angular/core";
import {
  PersistenceAction,
  Visitor,
  InstitutionByVisitor,
} from "../../../../../shared-lib/src/public-api";

@Injectable({ providedIn: "root" })
export class VisitorControlUtil {
  constructor() {}

  toSaveVisitor(username: string, institutions: number[]): Visitor {
    const institutionsByVisitor = institutions.map((institution) => {
      const instByVisitor = {
        visitorId: 0,
        institutionId: institution,
        modelAction: PersistenceAction.INSERT,
      } as InstitutionByVisitor;

      return instByVisitor;
    });
    const visitor = {
      id: 0,
      username: username,
      modelAction: PersistenceAction.INSERT,
      institutionsByVisitor: institutionsByVisitor,
    } as Visitor;
    return visitor;
  }
}
